/**
 * OLYX Custom JavaScript - Enhanced User Experience
 *
 * Currency converter removed: all prices render in the shop currency (EUR).
 * Old theme cart / shipping-protection code removed: handled by Cart Drawer Pro.
 *
 * Hooks:
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant;
 * });
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant;
 *   var quantity = event.detail.quantity;
 * });
 */

window.olyxGetLanguageString =
  window.olyxGetLanguageString ||
  function (key, fallback) {
    if (
      window.languages &&
      Object.prototype.hasOwnProperty.call(window.languages, key)
    ) {
      return window.languages[key];
    }

    return fallback;
  };

window.olyxFormatLanguageString =
  window.olyxFormatLanguageString ||
  function (key, fallback, replacements) {
    var template = String(window.olyxGetLanguageString(key, fallback) || "");

    if (!replacements) {
      return template;
    }

    Object.keys(replacements).forEach(function (token) {
      var value = String(replacements[token]);

      template = template
        .replace(new RegExp("\\{\\{\\s*" + token + "\\s*\\}\\}", "g"), value)
        .replace(new RegExp("__" + token.toUpperCase() + "__", "g"), value);
    });

    return template;
  };

// ============================================
// Shared money formatting (shop currency only)
// ============================================
window.olyxFormatMoney = function (cents) {
  var amount = parseInt(cents || 0, 10);
  var format =
    (window.theme && window.theme.moneyFormat) || "€{{amount}}";

  if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
    return window.Shopify.formatMoney(amount, format);
  }

  return "€" + (amount / 100).toFixed(2).replace(".", ",");
};

window.olyxBuildMoneySpan = function (cents, formattedMoney) {
  var safeText = String(formattedMoney || window.olyxFormatMoney(cents));
  return '<span class="money">' + safeText + "</span>";
};

(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    // ============================================
    // Smooth Scroll to Top Button
    // ============================================
    var scrollTopBtn = document.createElement("button");
    scrollTopBtn.innerHTML = "&#8593;";
    scrollTopBtn.className = "olyx-scroll-top";
    scrollTopBtn.style.cssText =
      "position: fixed; bottom: 30px; right: 30px; width: 50px; height: 50px; border-radius: 50%; background: linear-gradient(135deg, #000000, #000000); color: #fff; border: none; font-size: 24px; cursor: pointer; opacity: 0; transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1); z-index: 999; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4); font-weight: 700;";

    if (window.matchMedia("(max-width: 640px)").matches) {
      scrollTopBtn.style.bottom = "96px";
      scrollTopBtn.style.right = "16px";
      scrollTopBtn.style.width = "44px";
      scrollTopBtn.style.height = "44px";
      scrollTopBtn.style.fontSize = "21px";
    }
    document.body.appendChild(scrollTopBtn);

    window.addEventListener("scroll", function () {
      if (window.pageYOffset > 500) {
        scrollTopBtn.style.opacity = "1";
        scrollTopBtn.style.transform = "scale(1)";
      } else {
        scrollTopBtn.style.opacity = "0";
        scrollTopBtn.style.transform = "scale(0.8)";
      }
    });

    scrollTopBtn.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });

    scrollTopBtn.addEventListener("mouseenter", function () {
      this.style.transform = "scale(1.1) rotate(360deg)";
      this.style.boxShadow = "0 6px 30px rgba(0, 0, 0, 0.6)";
    });

    scrollTopBtn.addEventListener("mouseleave", function () {
      this.style.transform = "scale(1) rotate(0deg)";
      this.style.boxShadow = "0 4px 20px rgba(0, 0, 0, 0.4)";
    });

    // ============================================
    // Ripple Effect on Buttons
    // ============================================
    function createRipple(event) {
      var button = event.currentTarget;
      var circle = document.createElement("span");
      var diameter = Math.max(button.clientWidth, button.clientHeight);
      var radius = diameter / 2;

      circle.style.width = circle.style.height = diameter + "px";
      circle.style.left = event.clientX - button.offsetLeft - radius + "px";
      circle.style.top = event.clientY - button.offsetTop - radius + "px";
      circle.style.position = "absolute";
      circle.style.borderRadius = "50%";
      circle.style.background = "rgba(255, 255, 255, 0.6)";
      circle.style.transform = "scale(0)";
      circle.style.animation = "ripple 0.6s ease-out";
      circle.classList.add("ripple");

      var ripple = button.querySelector(".ripple");
      if (ripple) {
        ripple.remove();
      }

      button.appendChild(circle);
    }

    var buttons = document.querySelectorAll(".Button--primary, .Form__Submit");
    buttons.forEach(function (button) {
      button.style.position = "relative";
      button.style.overflow = "hidden";
      button.addEventListener("click", createRipple);
    });

    // ============================================
    // CSS Animations
    // ============================================
    var style = document.createElement("style");
    style.textContent = `
      @keyframes ripple {
        to {
          transform: scale(4);
          opacity: 0;
        }
      }
    `;
    document.head.appendChild(style);
  });
})();

// ============================================
// Product-link scroll restoration
// Keeps shoppers at the same spot when returning from a product page.
// ============================================
(function () {
  "use strict";

  var COLLECTION_SCROLL_KEY = "olyx_collection_scroll_state";
  var MAX_STATE_AGE = 30 * 60 * 1000;

  function supportsProductLinkScrollRestore() {
    return !!(
      document.body &&
      (document.body.classList.contains("template-collection") ||
        document.body.classList.contains("template-search") ||
        document.body.classList.contains("template-product"))
    );
  }

  function getCurrentListingPath() {
    return window.location.pathname + window.location.search;
  }

  function isSameOriginProductUrl(url) {
    if (!url) return false;

    try {
      var parsedUrl = new URL(url, window.location.origin);
      return (
        parsedUrl.origin === window.location.origin &&
        /\/products\//.test(parsedUrl.pathname)
      );
    } catch (error) {
      return false;
    }
  }

  function saveCollectionScrollState() {
    if (!supportsProductLinkScrollRestore()) {
      return;
    }

    try {
      window.sessionStorage.setItem(
        COLLECTION_SCROLL_KEY,
        JSON.stringify({
          path: getCurrentListingPath(),
          scrollY: Math.max(window.pageYOffset || 0, 0),
          savedAt: Date.now(),
        }),
      );
    } catch (error) {}
  }

  function readCollectionScrollState() {
    try {
      var rawValue = window.sessionStorage.getItem(COLLECTION_SCROLL_KEY);

      if (!rawValue) {
        return null;
      }

      var parsedValue = JSON.parse(rawValue);

      if (
        !parsedValue ||
        parsedValue.path !== getCurrentListingPath() ||
        typeof parsedValue.scrollY !== "number" ||
        !parsedValue.savedAt ||
        Date.now() - parsedValue.savedAt > MAX_STATE_AGE
      ) {
        return null;
      }

      return parsedValue;
    } catch (error) {
      return null;
    }
  }

  function clearCollectionScrollState() {
    try {
      window.sessionStorage.removeItem(COLLECTION_SCROLL_KEY);
    } catch (error) {}
  }

  function shouldRestoreCollectionScroll() {
    if (!supportsProductLinkScrollRestore()) {
      return false;
    }

    var navigationEntry =
      window.performance && window.performance.getEntriesByType
        ? window.performance.getEntriesByType("navigation")[0]
        : null;
    var isBackForwardNavigation = !!(
      navigationEntry && navigationEntry.type === "back_forward"
    );
    var cameFromProduct = isSameOriginProductUrl(document.referrer);

    return isBackForwardNavigation || cameFromProduct;
  }

  function restoreCollectionScroll() {
    if (window.__olyxPreRestoredScroll || window.__olyxPreRestoringScroll) {
      clearCollectionScrollState();
      return;
    }

    if (!shouldRestoreCollectionScroll()) {
      return;
    }

    var storedState = readCollectionScrollState();

    if (!storedState) {
      return;
    }

    clearCollectionScrollState();

    [0, 80, 180, 320].forEach(function (delay) {
      window.setTimeout(function () {
        window.scrollTo(0, storedState.scrollY);
      }, delay);
    });
  }

  document.addEventListener("click", function (event) {
    var productLink = event.target.closest(
      '.ProductItem a[href*="/products/"]',
    );

    if (!productLink || productLink.target === "_blank") {
      return;
    }

    if (!isSameOriginProductUrl(productLink.href)) {
      return;
    }

    saveCollectionScrollState();
  });

  document.addEventListener("DOMContentLoaded", restoreCollectionScroll);
  window.addEventListener("pageshow", function (event) {
    if (event && event.persisted) {
      clearCollectionScrollState();
      return;
    }

    restoreCollectionScroll();
  });
})();

// ============================================
// Inline Variant Selector (Color Swatches + Size Buttons)
// Keeps inline buttons, theme variant state and form variant ID in sync.
// ============================================
(function () {
  function normalizeValue(value) {
    return String(value || "")
      .trim()
      .toLowerCase();
  }

  function getProductRoot(el) {
    return el && el.closest
      ? el.closest('.Product, [data-section-type="product"]')
      : null;
  }

  function setInlineButtonState(btn) {
    var inlineGroup = btn.closest(".OlyxInline");
    if (!inlineGroup) return;
    var productRoot = getProductRoot(btn);

    var pos = btn.getAttribute("data-olyx-pos");
    var selector = '[data-olyx-pos="' + pos + '"]';
    var scope = productRoot || inlineGroup;

    scope.querySelectorAll(selector).forEach(function (b) {
      b.classList.remove("is-selected");
    });

    btn.classList.add("is-selected");

    var labelVal = inlineGroup.querySelector(".OlyxInline__LabelValue");
    if (labelVal) {
      labelVal.textContent = btn.getAttribute("data-olyx-val") || "";
    }
  }

  function getProductData(productRoot) {
    if (!productRoot) return null;
    if (productRoot._olyxProductData && productRoot._olyxProductData.variants) {
      return productRoot._olyxProductData;
    }

    var jsonNode = productRoot.querySelector("[data-product-json]");
    if (!jsonNode) return null;

    try {
      var parsed = JSON.parse(jsonNode.textContent || "{}");
      productRoot._olyxProductData = parsed.product || null;
      return productRoot._olyxProductData;
    } catch (err) {
      return null;
    }
  }

  function getSelectedOptionMap(productRoot) {
    var selectedByPos = {};

    productRoot
      .querySelectorAll("[data-olyx-pos].is-selected")
      .forEach(function (btn) {
        selectedByPos[String(btn.getAttribute("data-olyx-pos"))] =
          btn.getAttribute("data-olyx-val") || "";
      });

    return selectedByPos;
  }

  function rememberPreferredSelection(productRoot, pos, val) {
    if (!productRoot || !pos) return;
    if (!productRoot._olyxPreferredSelections) {
      productRoot._olyxPreferredSelections = {};
    }

    productRoot._olyxPreferredSelections[String(pos)] = String(val || "");
  }

  function getPreferredSelectionMap(productRoot) {
    return productRoot && productRoot._olyxPreferredSelections
      ? productRoot._olyxPreferredSelections
      : {};
  }

  function rememberLastInteraction(productRoot, pos, val, type) {
    if (!productRoot || !pos) return;
    productRoot._olyxLastInteraction = {
      pos: String(pos),
      val: String(val || ""),
      type: String(type || "generic"),
      at: Date.now(),
    };
  }

  function shouldSyncGalleryFromInteraction(productRoot) {
    if (!productRoot) return false;

    var last = productRoot._olyxLastInteraction;
    if (!last) return true;

    // Only move gallery on explicit color changes.
    return String(last.type || "") === "color";
  }

  function getVariantOptionByPos(variant, pos) {
    if (!variant || !pos) return "";
    return variant["option" + String(pos)] || "";
  }

  function variantHasActualStock(variant) {
    return !!(variant && variant.available);
  }

  function getVariantMatchScore(variant) {
    if (!variant) return -1;
    if (variantHasActualStock(variant)) return 2;
    return 0;
  }

  function pickBestMatchingVariant(variants, matcher) {
    var best = null;
    var bestScore = -1;

    (variants || []).forEach(function (variant) {
      if (!matcher(variant)) {
        return;
      }

      var score = getVariantMatchScore(variant);

      if (score > bestScore) {
        best = variant;
        bestScore = score;
      }
    });

    return best;
  }

  function doesVariantMatchSelection(variant, selectedByPos) {
    if (!variant || !selectedByPos) return false;

    return ["1", "2", "3"].every(function (pos) {
      return (
        !selectedByPos[pos] ||
        normalizeValue(getVariantOptionByPos(variant, pos)) ===
          normalizeValue(selectedByPos[pos])
      );
    });
  }

  function isInlineValueAvailable(productRoot, pos, val, selectedByPos) {
    var productData = getProductData(productRoot);
    var nextSelection = {
      1: (selectedByPos && selectedByPos["1"]) || "",
      2: (selectedByPos && selectedByPos["2"]) || "",
      3: (selectedByPos && selectedByPos["3"]) || "",
    };

    if (!productData || !productData.variants || !pos) {
      return true;
    }

    nextSelection[String(pos)] = String(val || "");

    return productData.variants.some(function (variant) {
      return (
        doesVariantMatchSelection(variant, nextSelection) &&
        variantHasActualStock(variant)
      );
    });
  }

  function syncInlineSizeButtonAvailability(productRoot) {
    if (!productRoot || !productRoot.querySelectorAll) return;

    var selectedByPos = getSelectedOptionMap(productRoot);
    var sizeButtons = productRoot.querySelectorAll(
      ".OlyxInline--size .OlyxSizeBtn[data-olyx-pos]",
    );

    Array.prototype.forEach.call(sizeButtons, function (btn) {
      var pos = String(btn.getAttribute("data-olyx-pos") || "");
      var val = btn.getAttribute("data-olyx-val") || "";
      var isAvailable = isInlineValueAvailable(
        productRoot,
        pos,
        val,
        selectedByPos,
      );

      btn.disabled = false;
      btn.classList.toggle("OlyxSizeBtn--soldout", !isAvailable);
      btn.setAttribute("aria-disabled", isAvailable ? "false" : "true");
      btn.removeAttribute("tabindex");
    });
  }

  function syncInlineAvailabilityInScope(root) {
    var scope = root || document;
    var productRoots = [];

    if (
      scope.matches &&
      scope.matches('.Product, [data-section-type="product"]')
    ) {
      productRoots.push(scope);
    }

    if (scope.querySelectorAll) {
      Array.prototype.forEach.call(
        scope.querySelectorAll('.Product, [data-section-type="product"]'),
        function (productRoot) {
          if (productRoots.indexOf(productRoot) === -1) {
            productRoots.push(productRoot);
          }
        },
      );
    }

    productRoots.forEach(function (productRoot) {
      syncInlineSizeButtonAvailability(productRoot);
    });
  }

  function findVariantFromInlineSelection(productRoot) {
    var productData = getProductData(productRoot);
    if (!productData || !productData.variants) return null;

    var selectedByPos = getSelectedOptionMap(productRoot);
    var hasAnySelection = Object.keys(selectedByPos).length > 0;
    if (!hasAnySelection) return null;

    return pickBestMatchingVariant(productData.variants, function (variant) {
      var ok1 =
        !selectedByPos["1"] ||
        normalizeValue(variant.option1) === normalizeValue(selectedByPos["1"]);
      var ok2 =
        !selectedByPos["2"] ||
        normalizeValue(variant.option2) === normalizeValue(selectedByPos["2"]);
      var ok3 =
        !selectedByPos["3"] ||
        normalizeValue(variant.option3) === normalizeValue(selectedByPos["3"]);

      return ok1 && ok2 && ok3;
    });
  }

  function findVariantFromSelectionMap(productRoot, selectedByPos) {
    var productData = getProductData(productRoot);
    if (!productData || !productData.variants) return null;

    var hasAnySelection =
      selectedByPos && Object.keys(selectedByPos).length > 0;
    if (!hasAnySelection) return null;

    return pickBestMatchingVariant(productData.variants, function (variant) {
      var ok1 =
        !selectedByPos["1"] ||
        normalizeValue(variant.option1) === normalizeValue(selectedByPos["1"]);
      var ok2 =
        !selectedByPos["2"] ||
        normalizeValue(variant.option2) === normalizeValue(selectedByPos["2"]);
      var ok3 =
        !selectedByPos["3"] ||
        normalizeValue(variant.option3) === normalizeValue(selectedByPos["3"]);

      return ok1 && ok2 && ok3;
    });
  }

  function findBestVariantForInteraction(productRoot, pos, val, preferredMap) {
    var productData = getProductData(productRoot);
    if (!productData || !productData.variants || !pos || !val) return null;

    var expected = normalizeValue(val);
    var best = null;
    var bestScore = -1;

    productData.variants.forEach(function (variant) {
      if (normalizeValue(getVariantOptionByPos(variant, pos)) !== expected)
        return;

      var score = 0;
      if (preferredMap) {
        ["1", "2", "3"].forEach(function (p) {
          var wanted = preferredMap[p];
          if (!wanted) return;
          if (
            normalizeValue(getVariantOptionByPos(variant, p)) ===
            normalizeValue(wanted)
          ) {
            score += 1;
          }
        });
      }

      if (variantHasActualStock(variant)) {
        score += 20;
      }

      if (score > bestScore) {
        best = variant;
        bestScore = score;
      }
    });

    return best;
  }

  function clickHiddenOptionButton(productRoot, pos, val) {
    if (!productRoot || !pos || !val) return false;

    var selector =
      '[data-action="select-value"][data-option-position="' + pos + '"]';
    var allBtns = productRoot.querySelectorAll(selector);

    for (var i = 0; i < allBtns.length; i++) {
      if (
        normalizeValue(allBtns[i].getAttribute("data-value")) ===
        normalizeValue(val)
      ) {
        allBtns[i].click();
        return true;
      }
    }

    return false;
  }

  function syncFormVariantId(productRoot, forcedVariant) {
    if (!productRoot) return;

    var form = productRoot.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var variant = forcedVariant || findVariantFromInlineSelection(productRoot);
    if (!variant || !variant.id) return;

    var idField = form.querySelector('[name="id"]');
    if (!idField) return;

    var idString = String(variant.id);

    if (idField.tagName === "SELECT") {
      idField.value = idString;

      Array.prototype.forEach.call(idField.options, function (opt) {
        if (String(opt.value) === idString) {
          opt.setAttribute("selected", "selected");
          opt.selected = true;
        } else {
          opt.removeAttribute("selected");
        }
      });
    } else {
      idField.value = idString;
    }

    idField.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function getVariantImageId(variant) {
    if (!variant) return null;

    if (variant.featured_image && variant.featured_image.id) {
      return String(variant.featured_image.id);
    }

    if (variant.image_id) {
      return String(variant.image_id);
    }

    if (variant.featured_media && variant.featured_media.id) {
      return String(variant.featured_media.id);
    }

    return null;
  }

  function syncProductGalleryToVariant(productRoot, variant) {
    if (!productRoot || !variant) return;

    var imageId = getVariantImageId(variant);
    if (!imageId) return;

    var targetHash = "#Image" + imageId;
    var navLink = productRoot.querySelector(
      '.Product__SlideshowNav a[href="' + targetHash + '"]',
    );
    var targetSlide = productRoot.querySelector(
      '.Product__SlideItem[data-image-id="' + imageId + '"]',
    );

    if (navLink && typeof navLink.click === "function") {
      navLink.click();
    }

    var slideshow = productRoot.querySelector(".Product__Slideshow");
    if (
      slideshow &&
      targetSlide &&
      window.Flickity &&
      typeof window.Flickity.data === "function"
    ) {
      var flkty = window.Flickity.data(slideshow);
      if (flkty && typeof flkty.select === "function") {
        var index = -1;

        for (var i = 0; i < flkty.cells.length; i++) {
          var cellElem = flkty.cells[i] && flkty.cells[i].element;
          if (cellElem && cellElem.getAttribute("data-image-id") === imageId) {
            index = i;
            break;
          }
        }

        if (index >= 0) {
          flkty.select(index, false, true);
        }
      }
    }

    if (targetSlide) {
      productRoot
        .querySelectorAll(".Product__SlideItem.is-selected")
        .forEach(function (el) {
          el.classList.remove("is-selected");
        });
      targetSlide.classList.add("is-selected");
    }

    if (navLink) {
      productRoot
        .querySelectorAll(".Product__SlideshowNav a.is-selected")
        .forEach(function (el) {
          el.classList.remove("is-selected");
        });
      navLink.classList.add("is-selected");
    }
  }

  function syncInlineSelectionFromVariant(productRoot, variant) {
    if (!productRoot || !variant) return;

    var valuesByPos = {
      1: variant.option1,
      2: variant.option2,
      3: variant.option3,
    };

    Object.keys(valuesByPos).forEach(function (pos) {
      var expected = valuesByPos[pos];
      if (!expected) return;

      var candidates = productRoot.querySelectorAll(
        '[data-olyx-pos="' + pos + '"]',
      );
      var matches = [];

      Array.prototype.forEach.call(candidates, function (btn) {
        btn.classList.remove("is-selected");
        if (
          normalizeValue(btn.getAttribute("data-olyx-val")) ===
          normalizeValue(expected)
        ) {
          matches.push(btn);
        }
      });

      matches.forEach(function (btn) {
        btn.classList.add("is-selected");

        var inlineGroup = btn.closest(".OlyxInline");
        if (!inlineGroup) return;

        var labelVal = inlineGroup.querySelector(".OlyxInline__LabelValue");
        if (labelVal) {
          labelVal.textContent = btn.getAttribute("data-olyx-val") || "";
        }
      });
    });
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-olyx-pos]");
    if (!btn || btn.disabled) return;

    var pos = btn.getAttribute("data-olyx-pos");
    var val = btn.getAttribute("data-olyx-val");
    var popoverId = btn.getAttribute("data-olyx-popover");
    var productRoot = getProductRoot(btn);
    var interactionType = btn.classList.contains("OlyxColorSwatch")
      ? "color"
      : btn.classList.contains("OlyxSizeBtn")
        ? "size"
        : "generic";

    setInlineButtonState(btn);

    if (interactionType === "color") {
      syncInlineSizeButtonAvailability(productRoot);
    }

    rememberPreferredSelection(productRoot, pos, val);
    rememberLastInteraction(productRoot, pos, val, interactionType);

    // Prevent focus styles from masking the selected state until the next click elsewhere.
    setTimeout(function () {
      if (btn && typeof btn.blur === "function") {
        btn.blur();
      }
    }, 0);

    // Delegate to hidden theme option buttons so theme JS updates image, inventory and availability.
    var popover = document.getElementById(popoverId);
    if (popover) {
      var allBtns = popover.querySelectorAll(
        '[data-action="select-value"][data-option-position="' + pos + '"]',
      );
      var matched = false;

      for (var i = 0; i < allBtns.length; i++) {
        if (
          normalizeValue(allBtns[i].getAttribute("data-value")) ===
          normalizeValue(val)
        ) {
          allBtns[i].click();
          matched = true;
          break;
        }
      }

      if (matched) {
        // Ensure the form ID is synchronized even on very fast user interactions.
        setTimeout(function () {
          var pickedVariant = findVariantFromInlineSelection(productRoot);
          syncFormVariantId(productRoot, pickedVariant);
          if (interactionType === "color") {
            syncProductGalleryToVariant(productRoot, pickedVariant);
          }
        }, 0);
        return;
      }
    }

    // Fallback in case a matching hidden option button is not found.
    var fallbackVariant = findVariantFromInlineSelection(productRoot);
    syncFormVariantId(productRoot, fallbackVariant);
    if (interactionType === "color") {
      syncProductGalleryToVariant(productRoot, fallbackVariant);
    }
  });

  document.addEventListener("variant:changed", function (e) {
    var variant = e.detail && e.detail.variant;
    var productRoot = getProductRoot(e.target);
    if (!variant || !productRoot) return;

    if (productRoot._olyxAdjustingVariant) {
      syncInlineSelectionFromVariant(productRoot, variant);
      syncInlineSizeButtonAvailability(productRoot);
      syncFormVariantId(productRoot, variant);
      return;
    }

    var last = productRoot._olyxLastInteraction;
    if (last && Date.now() - Number(last.at || 0) < 1200) {
      var lastPos = String(last.pos || "");
      var lastVal = String(last.val || "");
      var currentAtLastPos = getVariantOptionByPos(variant, lastPos);

      if (
        lastPos &&
        lastVal &&
        normalizeValue(currentAtLastPos) !== normalizeValue(lastVal)
      ) {
        var preferredForLast = getPreferredSelectionMap(productRoot);
        var correctedVariant = findBestVariantForInteraction(
          productRoot,
          lastPos,
          lastVal,
          preferredForLast,
        );

        if (
          correctedVariant &&
          correctedVariant.id &&
          String(correctedVariant.id) !== String(variant.id)
        ) {
          productRoot._olyxAdjustingVariant = true;

          clickHiddenOptionButton(productRoot, "1", correctedVariant.option1);
          clickHiddenOptionButton(productRoot, "2", correctedVariant.option2);
          clickHiddenOptionButton(productRoot, "3", correctedVariant.option3);

          setTimeout(function () {
            productRoot._olyxAdjustingVariant = false;
          }, 0);

          return;
        }
      }
    }

    // Keep user intent sticky: if a size change can still match a previously chosen color,
    // force the variant back to that preferred combination.
    var preferred = getPreferredSelectionMap(productRoot);
    var wanted = {
      1: preferred["1"] || variant.option1,
      2: preferred["2"] || variant.option2,
      3: preferred["3"] || variant.option3,
    };

    var preferredVariant = findVariantFromSelectionMap(productRoot, wanted);
    if (
      preferredVariant &&
      preferredVariant.id &&
      String(preferredVariant.id) !== String(variant.id)
    ) {
      productRoot._olyxAdjustingVariant = true;

      clickHiddenOptionButton(productRoot, "1", preferredVariant.option1);
      clickHiddenOptionButton(productRoot, "2", preferredVariant.option2);
      clickHiddenOptionButton(productRoot, "3", preferredVariant.option3);

      setTimeout(function () {
        productRoot._olyxAdjustingVariant = false;
      }, 0);

      return;
    }

    syncInlineSelectionFromVariant(productRoot, variant);
    syncInlineSizeButtonAvailability(productRoot);
    rememberPreferredSelection(productRoot, "1", variant.option1);
    rememberPreferredSelection(productRoot, "2", variant.option2);
    rememberPreferredSelection(productRoot, "3", variant.option3);
    syncFormVariantId(productRoot, variant);
    if (shouldSyncGalleryFromInteraction(productRoot)) {
      syncProductGalleryToVariant(productRoot, variant);
    }
  });

  // Last line of defense: always send the correct variant ID to cart.
  document.addEventListener(
    "submit",
    function (e) {
      var form = e.target;
      if (
        !form ||
        form.tagName !== "FORM" ||
        !form.matches('form[action*="/cart/add"]')
      )
        return;

      var productRoot = getProductRoot(form);
      if (!productRoot) return;

      syncFormVariantId(productRoot);
    },
    true,
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      syncInlineAvailabilityInScope(document);
    });
  } else {
    syncInlineAvailabilityInScope(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    syncInlineAvailabilityInScope(event.target);
  });
})();

// ============================================
// Sync custom price display with variant changes
// Updates OlyxPrice Sale/Compare/SaveBadge and OlyxLowStock
// whenever the theme fires a variant:changed event.
// ============================================
(function () {
  function buildMoneyMarkup(cents) {
    return window.olyxBuildMoneySpan(cents);
  }

  function hasComparePrice(variant) {
    return !!(
      variant &&
      variant.compare_at_price &&
      variant.compare_at_price > variant.price
    );
  }

  function syncPdpPriceDisplay(section, variant) {
    var salEl = section.querySelector(".OlyxPrice__Sale");
    var cmpEl = section.querySelector(".OlyxPrice__Compare");
    var badgeEl = section.querySelector(".OlyxPrice__SaveBadge");
    var savings = 0;

    if (!salEl || !variant) {
      return;
    }

    salEl.innerHTML = buildMoneyMarkup(variant.price);

    if (hasComparePrice(variant)) {
      if (!cmpEl) {
        cmpEl = document.createElement("span");
        cmpEl.className = "OlyxPrice__Compare";
        salEl.insertAdjacentElement("afterend", cmpEl);
      }

      cmpEl.innerHTML = buildMoneyMarkup(variant.compare_at_price);
      cmpEl.style.display = "";

      if (!badgeEl) {
        badgeEl = document.createElement("span");
        badgeEl.className = "OlyxPrice__SaveBadge";
        cmpEl.insertAdjacentElement("afterend", badgeEl);
      }

      savings = Math.max(variant.compare_at_price - variant.price, 0);
      badgeEl.innerHTML =
        window.olyxGetLanguageString("saveAmountPrefix", "SAVE") +
        " " +
        buildMoneyMarkup(savings);
      badgeEl.style.display = "";
      return;
    }

    if (cmpEl) {
      cmpEl.style.display = "none";
      cmpEl.innerHTML = "";
    }

    if (badgeEl) {
      badgeEl.style.display = "none";
      badgeEl.innerHTML = "";
    }
  }

  document.addEventListener("variant:changed", function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;
    var section = e.target.closest('.Product, [data-section-type="product"]');
    if (!section) return;

    var lowEl = section.querySelector(".OlyxLowStock");

    syncPdpPriceDisplay(section, variant);

    // Low stock
    if (lowEl) {
      lowEl.style.display =
        variant.inventory_management &&
        variant.inventory_quantity > 0 &&
        variant.inventory_quantity <= 10
          ? "flex"
          : "none";
    }
  });
})();

// ============================================
// Product card swatch sync (collection/grid items)
// ============================================
(function () {
  if (!document.getElementById("olyx-card-swatch-style")) {
    var swatchStyle = document.createElement("style");
    swatchStyle.id = "olyx-card-swatch-style";
    swatchStyle.textContent =
      ".ProductItem__ColorSwatchItem .ColorSwatch.is-selected{box-shadow:0 0 0 0.6px #111 inset,0 0 0 0.3px #111;transform:none !important;}";
    document.head.appendChild(swatchStyle);
  }

  function formatMoney(cents) {
    return window.olyxFormatMoney(cents);
  }

  function updateCardPrice(card, radio) {
    if (!card || !radio) return;

    var priceList = card.querySelector(".ProductItem__PriceList");
    if (!priceList) return;

    var rawPrice = parseInt(
      radio.getAttribute("data-variant-price") || "0",
      10,
    );
    if (!rawPrice) return;

    var rawCompare = parseInt(
      radio.getAttribute("data-variant-compare-at-price") || "0",
      10,
    );

    if (rawCompare > rawPrice) {
      priceList.innerHTML =
        '<span class="ProductItem__Price Price Price--highlight Text--subdued">' +
        window.olyxBuildMoneySpan(rawPrice, formatMoney(rawPrice)) +
        "</span>" +
        '<span class="ProductItem__Price Price Price--compareAt Text--subdued">' +
        window.olyxBuildMoneySpan(rawCompare, formatMoney(rawCompare)) +
        "</span>";
    } else {
      priceList.innerHTML =
        '<span class="ProductItem__Price Price Text--subdued">' +
        window.olyxBuildMoneySpan(rawPrice, formatMoney(rawPrice)) +
        "</span>";
    }
  }

  function updateCardSwatchVisuals(card, selectedRadio) {
    if (!card || !selectedRadio) return;

    var groupName = selectedRadio.getAttribute("name");
    if (!groupName) return;

    var radios = card.querySelectorAll(
      '.ColorSwatch__Radio[name="' + groupName + '"]',
    );
    Array.prototype.forEach.call(radios, function (radio) {
      var label = card.querySelector('label[for="' + radio.id + '"]');
      if (!label) return;

      if (radio === selectedRadio) {
        label.classList.add("is-selected");
      } else {
        label.classList.remove("is-selected");
      }
    });
  }

  function imageUrlFromTemplate(urlTemplate, width) {
    var tpl = String(urlTemplate || "");
    if (!tpl) return "";
    if (tpl.indexOf("{width}") >= 0) {
      return tpl.replace("{width}", String(width || 600));
    }
    return tpl;
  }

  function buildSrcsetFromTemplate(urlTemplate, widths) {
    var tpl = String(urlTemplate || "");
    if (!tpl) return "";

    var list = [];
    var parsed = String(widths || "").replace(/\[|\]|\s/g, "");

    if (parsed) {
      parsed.split(",").forEach(function (w) {
        var widthNum = parseInt(w, 10);
        if (widthNum > 0) {
          list.push(widthNum);
        }
      });
    }

    if (!list.length) {
      list = [200, 300, 400, 600, 800, 900, 1000, 1200];
    }

    return list
      .map(function (w) {
        return imageUrlFromTemplate(tpl, w) + " " + w + "w";
      })
      .join(", ");
  }

  function applyCardImageSource(img, template, imageId, widths) {
    if (!img || !template) return;

    var src = imageUrlFromTemplate(template, 600);
    var srcset = buildSrcsetFromTemplate(template, widths);

    img.setAttribute("data-src", template);
    img.setAttribute("data-original-src", template);
    if (imageId) {
      img.setAttribute("data-image-id", String(imageId));
    }
    if (widths) {
      img.setAttribute("data-widths", widths);
    }

    if (srcset) {
      img.setAttribute("data-srcset", srcset);
      img.setAttribute("srcset", srcset);
    }

    img.setAttribute("src", src);
  }

  function updateCardImages(card, radio) {
    if (!card || !radio) return;

    var primary = card.querySelector(
      ".ProductItem__Image:not(.ProductItem__Image--alternate)",
    );
    if (!primary) return;

    var primaryTemplate = radio.getAttribute("data-image-url") || "";
    var altTemplate =
      radio.getAttribute("data-image-alt-url") || primaryTemplate;
    var primaryImageId = radio.getAttribute("data-image-id") || "";
    var widths = radio.getAttribute("data-image-widths") || "";

    applyCardImageSource(primary, primaryTemplate, primaryImageId, widths);

    var alternate = card.querySelector(".ProductItem__Image--alternate");
    if (alternate && altTemplate) {
      applyCardImageSource(alternate, altTemplate, "", widths);
      alternate.style.opacity = "0";
    }

    card._olyxPrimaryTemplate = primaryTemplate;
    card._olyxPrimaryImageId = primaryImageId;
    card._olyxAltTemplate = altTemplate;
    card._olyxWidths = widths;

    // Theme scripts can run after swatch click; re-apply once to keep selected hover image stable.
    setTimeout(function () {
      applyCardImageSource(primary, primaryTemplate, primaryImageId, widths);
      if (alternate && altTemplate) {
        applyCardImageSource(alternate, altTemplate, "", widths);
      }
    }, 90);
  }

  function ensureCardHoverReapply(card) {
    if (!card || card._olyxHoverReapplyBound) return;

    var wrapper = card.querySelector(
      ".ProductItem__ImageWrapper--withAlternateImage",
    );
    if (!wrapper) return;

    card._olyxHoverReapplyBound = true;

    wrapper.addEventListener("mouseenter", function () {
      var selected =
        card.querySelector(".ColorSwatch__Radio:checked") ||
        card.querySelector(".ColorSwatch__Radio");
      if (selected) {
        updateCardImages(card, selected);
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".ProductItem").forEach(function (card) {
      var selected =
        card.querySelector(".ColorSwatch__Radio:checked") ||
        card.querySelector(".ColorSwatch__Radio");
      if (selected) {
        updateCardImages(card, selected);
      }
      ensureCardHoverReapply(card);
    });
  });

  document.addEventListener("change", function (e) {
    var radio = e.target;
    if (!radio || !radio.matches(".ColorSwatch__Radio")) return;

    var card = radio.closest(".ProductItem");
    if (!card) return;

    updateCardSwatchVisuals(card, radio);
    updateCardImages(card, radio);
    ensureCardHoverReapply(card);
    updateCardPrice(card, radio);
  });
})();

// ============================================
// Product card quick add
// ============================================
(function () {
  "use strict";

  var quickAddDrawer = null;
  var activeContainer = null;
  var activeProductItem = null;
  var activeSourceButtons = [];
  var selectedSourceIndex = -1;
  var activeColorValue = "";
  var activeColorPosition = 0;

  function forEachNode(nodeList, callback) {
    Array.prototype.forEach.call(nodeList || [], callback);
  }

  function lockQuickAddPageScroll() {
    var docEl = document.documentElement;
    var body = document.body;
    var scrollY =
      window.pageYOffset || docEl.scrollTop || (body && body.scrollTop) || 0;

    if (!body || body.getAttribute("data-olyx-quick-add-locked") === "true") {
      return;
    }

    body.setAttribute("data-olyx-quick-add-locked", "true");
    body.setAttribute("data-olyx-quick-add-scroll-y", String(scrollY));
    docEl.classList.add("QuickAddDrawer-open");
    body.classList.add("QuickAddDrawer-open");
    body.style.top = "-" + scrollY + "px";
  }

  function unlockQuickAddPageScroll(restoreScroll) {
    var docEl = document.documentElement;
    var body = document.body;
    var shouldRestoreScroll = restoreScroll !== false;
    var storedScrollY = 0;

    if (!body) {
      return;
    }

    storedScrollY = parseInt(
      body.getAttribute("data-olyx-quick-add-scroll-y") || "0",
      10,
    );

    docEl.classList.remove("QuickAddDrawer-open");
    body.classList.remove("QuickAddDrawer-open");
    body.style.top = "";
    body.removeAttribute("data-olyx-quick-add-scroll-y");
    body.removeAttribute("data-olyx-quick-add-locked");

    if (shouldRestoreScroll) {
      window.scrollTo(0, isNaN(storedScrollY) ? 0 : storedScrollY);
    }
  }

  function resetQuickAddDrawerState() {
    var drawer = quickAddDrawer || document.getElementById("QuickAddDrawer");

    if (drawer) {
      drawer.setAttribute("aria-hidden", "true");
    }

    unlockQuickAddPageScroll();
  }

  function buildMoneyMarkup(cents) {
    return window.olyxBuildMoneySpan(cents);
  }

  function ensureQuickAddDrawer() {
    if (quickAddDrawer) {
      return quickAddDrawer;
    }

    quickAddDrawer = document.createElement("div");
    quickAddDrawer.className = "QuickAddDrawer";
    quickAddDrawer.id = "QuickAddDrawer";
    quickAddDrawer.setAttribute("aria-hidden", "true");
    quickAddDrawer.innerHTML =
      '<div class="QuickAddDrawer__Backdrop" data-quick-add-close></div>' +
      '<aside class="QuickAddDrawer__Panel" role="dialog" aria-modal="true" aria-labelledby="QuickAddDrawerTitle">' +
      '<div class="QuickAddDrawer__Header">' +
      '<div class="QuickAddDrawer__HeaderMain">' +
      '<h2 class="QuickAddDrawer__Title" id="QuickAddDrawerTitle"></h2>' +
      '<span class="QuickAddDrawer__Badge" hidden></span>' +
      "</div>" +
      '<button type="button" class="QuickAddDrawer__Close" data-quick-add-close>' +
      '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M4 4l10 10" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M14 4L4 14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
      "</button>" +
      "</div>" +
      '<div class="QuickAddDrawer__Body">' +
      '<section class="QuickAddDrawer__State" data-quick-add-state="picker">' +
      '<a class="QuickAddDrawer__Summary" data-quick-add-product-link>' +
      '<div class="QuickAddDrawer__SummaryImageWrap"><img class="QuickAddDrawer__SummaryImage" data-quick-add-image alt=""></div>' +
      '<div class="QuickAddDrawer__SummaryContent">' +
      '<h3 class="QuickAddDrawer__ProductTitle" data-quick-add-product-title></h3>' +
      '<div class="QuickAddDrawer__ProductPrice" data-quick-add-product-price></div>' +
      "</div>" +
      "</a>" +
      '<div class="QuickAddDrawer__Status" data-quick-add-status></div>' +
      '<div class="QuickAddDrawer__ColorGroup" data-quick-add-color-group hidden>' +
      '<div class="QuickAddDrawer__ColorHeader">' +
      '<span class="QuickAddDrawer__ColorLabel"></span>' +
      '<span class="QuickAddDrawer__ColorValue" data-quick-add-color-value></span>' +
      "</div>" +
      '<div class="QuickAddDrawer__ColorList" data-quick-add-color-list></div>' +
      "</div>" +
      '<div class="QuickAddDrawer__Options" data-quick-add-options-list></div>' +
      '<div class="QuickAddDrawer__Footer">' +
      '<button type="button" class="QuickAddDrawer__AddButton" data-quick-add-submit disabled>' +
      '<span class="QuickAddDrawer__AddButtonLabel"></span>' +
      '<span class="QuickAddDrawer__AddButtonPrice" data-quick-add-submit-price></span>' +
      "</button>" +
      '<div class="QuickAddDrawer__Payments" data-quick-add-payments></div>' +
      "</div>" +
      "</section>" +
      "</div>" +
      "</aside>";

    document.body.appendChild(quickAddDrawer);
    return quickAddDrawer;
  }

  function getDrawerElements() {
    var drawer = ensureQuickAddDrawer();

    return {
      drawer: drawer,
      pickerState: drawer.querySelector('[data-quick-add-state="picker"]'),
      title: drawer.querySelector(".QuickAddDrawer__Title"),
      badge: drawer.querySelector(".QuickAddDrawer__Badge"),
      close: drawer.querySelector(".QuickAddDrawer__Close"),
      colorLabel: drawer.querySelector(".QuickAddDrawer__ColorLabel"),
      colorGroup: drawer.querySelector("[data-quick-add-color-group]"),
      colorList: drawer.querySelector("[data-quick-add-color-list]"),
      colorValue: drawer.querySelector("[data-quick-add-color-value]"),
      productLinks: drawer.querySelectorAll("[data-quick-add-product-link]"),
      productImage: drawer.querySelector("[data-quick-add-image]"),
      productTitle: drawer.querySelector("[data-quick-add-product-title]"),
      productPrice: drawer.querySelector("[data-quick-add-product-price]"),
      optionsList: drawer.querySelector("[data-quick-add-options-list]"),
      status: drawer.querySelector("[data-quick-add-status]"),
      submit: drawer.querySelector("[data-quick-add-submit]"),
      submitLabel: drawer.querySelector(".QuickAddDrawer__AddButtonLabel"),
      submitPrice: drawer.querySelector("[data-quick-add-submit-price]"),
      payments: drawer.querySelector("[data-quick-add-payments]"),
    };
  }

  function syncQuickAddStaticLabels(elements) {
    if (!elements) {
      return;
    }

    if (elements.close) {
      elements.close.setAttribute(
        "aria-label",
        window.olyxGetLanguageString("closeQuickAdd", "Close quick add"),
      );
    }

    if (elements.colorLabel) {
      elements.colorLabel.textContent = window.olyxGetLanguageString(
        "colorLabel",
        "Color",
      );
    }

    if (elements.submitLabel) {
      elements.submitLabel.textContent = window.olyxGetLanguageString(
        "addToCart",
        "Add to cart",
      );
    }
  }

  function setQuickAddStatus(message, tone) {
    var elements = getDrawerElements();
    var status = elements.status;

    if (!status) return;

    status.textContent = message || "";
    status.classList.remove(
      "is-visible",
      "QuickAddDrawer__Status--success",
      "QuickAddDrawer__Status--error",
    );

    if (!message) {
      return;
    }

    status.classList.add("is-visible");

    if (tone === "success") {
      status.classList.add("QuickAddDrawer__Status--success");
    }

    if (tone === "error") {
      status.classList.add("QuickAddDrawer__Status--error");
    }
  }

  function getSummaryImage(container) {
    var productItem = container.closest("[data-product-item]");
    var colorPosition = parseInt(
      container.getAttribute("data-color-option-position") || "0",
      10,
    );
    var selectedSwatch = null;

    if (productItem && activeColorValue && colorPosition) {
      selectedSwatch = productItem.querySelector(
        '.ColorSwatch__Radio[data-option-position="' +
          colorPosition +
          '"][value="' +
          CSS.escape(activeColorValue) +
          '"][data-image-url]',
      );
    }

    if (!selectedSwatch && productItem) {
      selectedSwatch = productItem.querySelector(
        ".ColorSwatch__Radio:checked[data-image-url]",
      );
    }

    var swatchImage = selectedSwatch
      ? (selectedSwatch.getAttribute("data-image-url") || "").replace(
          "{width}",
          "320",
        )
      : "";

    return swatchImage || container.getAttribute("data-product-image") || "";
  }

  function setDrawerState(state) {
    var elements = getDrawerElements();

    elements.pickerState.hidden = state !== "picker";
  }

  function setDrawerOpen(open) {
    var elements = getDrawerElements();

    elements.drawer.setAttribute("aria-hidden", open ? "false" : "true");

    if (open) {
      lockQuickAddPageScroll();
    } else {
      unlockQuickAddPageScroll();
    }

    if (!open) {
      if (activeContainer) {
        var trigger = activeContainer.querySelector("[data-quick-add-open]");

        if (trigger) {
          trigger.setAttribute("aria-expanded", "false");
        }
      }

      activeContainer = null;
      activeProductItem = null;
      activeSourceButtons = [];
      selectedSourceIndex = -1;
      activeColorValue = "";
      activeColorPosition = 0;
      setQuickAddStatus("");
      setDrawerState("picker");
    }
  }

  function getSelectedOptions(productItem, container) {
    var selectedOptions = {
      1: container.getAttribute("data-default-option1") || "",
      2: container.getAttribute("data-default-option2") || "",
      3: container.getAttribute("data-default-option3") || "",
    };

    forEachNode(
      productItem.querySelectorAll(
        ".ColorSwatch__Radio:checked[data-option-position]",
      ),
      function (swatch) {
        var optionPosition = parseInt(
          swatch.getAttribute("data-option-position") || "0",
          10,
        );

        if (optionPosition >= 1 && optionPosition <= 3) {
          selectedOptions[optionPosition] = swatch.value || "";
        }
      },
    );

    return selectedOptions;
  }

  function syncQuickAdd(productItem) {
    var container = productItem.querySelector("[data-quick-add-container]");
    var sizeButtons;
    var sizeOptionPosition;
    var selectedOptions;
    var visibleCount = 0;

    if (!container) return;

    sizeButtons = container.querySelectorAll(".ProductItem__QuickAddSize");
    sizeOptionPosition = parseInt(
      container.getAttribute("data-size-option-position") || "0",
      10,
    );

    if (!sizeButtons.length || !sizeOptionPosition) return;

    selectedOptions = getSelectedOptions(productItem, container);

    forEachNode(sizeButtons, function (button) {
      var matches = true;

      [1, 2, 3].forEach(function (position) {
        var selectedValue;
        var buttonValue;

        if (position === sizeOptionPosition) return;

        selectedValue = selectedOptions[position];
        buttonValue = button.getAttribute("data-option" + position) || "";

        if (selectedValue && buttonValue && selectedValue !== buttonValue) {
          matches = false;
        }
      });

      button.classList.toggle("is-hidden", !matches);

      if (!matches) {
        button.classList.remove("is-selected");
        button.setAttribute("tabindex", "-1");
        return;
      }

      visibleCount += 1;
      button.removeAttribute("tabindex");
    });

    container.classList.toggle(
      "ProductItem__QuickAdd--empty",
      visibleCount === 0,
    );

    if (activeContainer === container && quickAddDrawer) {
      renderQuickAddDrawer(container);
    }
  }

  function getVisibleSourceButtons(container) {
    var sourceButtons = [];

    forEachNode(
      container.querySelectorAll(
        ".ProductItem__QuickAddSize, .ProductItem__QuickAddVariant",
      ),
      function (button) {
        var matchesActiveColor = true;

        if (activeColorPosition && activeColorValue) {
          matchesActiveColor =
            (button.getAttribute("data-option" + activeColorPosition) || "") ===
            activeColorValue;
        }

        if (
          matchesActiveColor &&
          (activeColorPosition && activeColorValue
            ? true
            : !button.classList.contains("is-hidden"))
        ) {
          sourceButtons.push(button);
        }
      },
    );

    return sourceButtons;
  }

  function getQuickAddColorChoices(container) {
    var colorChoices = [];
    var seen = {};

    forEachNode(
      container.querySelectorAll(
        ".ProductItem__QuickAddSize, .ProductItem__QuickAddVariant",
      ),
      function (button) {
        var colorValue =
          button.getAttribute("data-option" + activeColorPosition) || "";

        if (!colorValue || seen[colorValue]) {
          return;
        }

        seen[colorValue] = true;
        colorChoices.push(colorValue);
      },
    );

    return colorChoices;
  }

  function updateSelectedColor(colorValue) {
    if (!activeContainer || !activeColorPosition) {
      return;
    }

    activeColorValue = String(colorValue || "");
    renderQuickAddDrawer(activeContainer);
  }

  function updateSelectedOption(index) {
    var elements = getDrawerElements();
    var sourceButton = activeSourceButtons[index];

    selectedSourceIndex = index;

    forEachNode(
      elements.optionsList.querySelectorAll("[data-quick-add-option]"),
      function (optionButton) {
        var optionIndex = parseInt(
          optionButton.getAttribute("data-source-index") || "-1",
          10,
        );

        optionButton.classList.toggle("is-selected", optionIndex === index);
      },
    );

    if (!sourceButton) {
      elements.submit.setAttribute("disabled", "disabled");
      elements.submitPrice.innerHTML = "";
      return;
    }

    elements.submit.removeAttribute("disabled");
    elements.submitPrice.innerHTML = buildMoneyMarkup(
      sourceButton.getAttribute("data-variant-price") || "0",
    );
  }

  /* ------------------------------------------------------------------ *
   * Sets with two sizes (e.g. a summer set: T-shirt size + Shorts size).
   * Instead of listing every combination ("XS / XS", "XS / S", ...) the
   * drawer shows one row of buttons per option. Colour stays in its own
   * colour row above. The shopper must pick every row before adding.
   * ------------------------------------------------------------------ */
  var multiState = null;

  function getAllSourceButtons(container) {
    var out = [];
    forEachNode(
      container.querySelectorAll(
        ".ProductItem__QuickAddSize, .ProductItem__QuickAddVariant",
      ),
      function (button) {
        if (
          activeColorPosition &&
          activeColorValue &&
          (button.getAttribute("data-option" + activeColorPosition) || "") !==
            activeColorValue
        ) {
          return;
        }
        out.push(button);
      },
    );
    return out;
  }

  function getMultiOptionPositions(container, buttons) {
    var colorPosition = parseInt(
      container.getAttribute("data-color-option-position") || "0",
      10,
    );
    var positions = [];
    [1, 2, 3].forEach(function (position) {
      var seen = {};
      var count = 0;
      if (position === colorPosition) return;
      forEachNode(buttons, function (button) {
        var value = button.getAttribute("data-option" + position) || "";
        if (value && !seen[value]) {
          seen[value] = true;
          count += 1;
        }
      });
      if (count > 1) positions.push(position);
    });
    return positions;
  }

  function prettyOptionName(raw, position, allNames) {
    var name = String(raw || "").trim();
    var lower = name.toLowerCase();
    var garment = function (text) {
      var t = String(text || "").toLowerCase();
      if (/t-?h?i?rt|t-shirt|tee\b|shirt/.test(t)) return "T-shirt";
      if (/korte broek|^shorts?$|\bshorts?\b/.test(t)) return "Shorts";
      if (/lange broek|pants|trousers|broek|jogger|sweatpant/.test(t)) return "Pants";
      if (/hoodie/.test(t)) return "Hoodie";
      if (/sweater|crewneck/.test(t)) return "Sweater";
      if (/jacket/.test(t)) return "Jacket";
      return "";
    };
    var piece = garment(name);
    if (!piece && /^(size|maat|mate|taille|größe|talla|taglia)$/.test(lower)) {
      /* a plain "Size" next to a garment option: name it after the matching top */
      var others = (allNames || []).filter(function (n, i) {
        return i + 1 !== position;
      });
      var otherPiece = garment(others.join(" "));
      if (otherPiece === "Shorts") piece = "T-shirt";
      else if (otherPiece === "Pants") piece = "Hoodie";
    }
    if (piece) return piece + " size";
    if (!name) return "Option " + position;
    return name.charAt(0).toUpperCase() + name.slice(1);
  }

  function renderMultiOptionPicker(container, elements, buttons, positions) {
    var names = (container.getAttribute("data-option-names") || "").split("||");

    activeSourceButtons = buttons;
    selectedSourceIndex = -1;
    multiState = { positions: positions, picks: {} };
    elements.optionsList.innerHTML = "";

    positions.forEach(function (position) {
      var group = document.createElement("div");
      var header = document.createElement("p");
      var label = document.createElement("span");
      var value = document.createElement("span");
      var list = document.createElement("div");
      var seen = {};

      group.className = "QuickAddDrawer__OptGroup";
      group.setAttribute("data-opt-group", position);
      header.className = "QuickAddDrawer__OptGroupHeader";
      label.className = "QuickAddDrawer__OptGroupLabel";
      label.textContent = prettyOptionName(names[position - 1], position, names);
      value.className = "QuickAddDrawer__OptGroupValue";
      value.setAttribute("data-opt-group-value", position);
      header.appendChild(label);
      header.appendChild(value);
      list.className = "QuickAddDrawer__OptGroupList";

      forEachNode(buttons, function (button) {
        var optionValue = button.getAttribute("data-option" + position) || "";
        var valueButton;
        if (!optionValue || seen[optionValue]) return;
        seen[optionValue] = true;
        valueButton = document.createElement("button");
        valueButton.type = "button";
        valueButton.className = "QuickAddDrawer__OptValue";
        valueButton.setAttribute("data-opt-position", position);
        valueButton.setAttribute("data-opt-value", optionValue);
        valueButton.textContent = olyxQuickSizeLabel(optionValue);
        list.appendChild(valueButton);
      });

      group.appendChild(header);
      group.appendChild(list);
      elements.optionsList.appendChild(group);
    });

    syncMultiOptionPicker();
  }

  function syncMultiOptionPicker() {
    var elements;
    var matchIndex = -1;
    if (!multiState) return;
    elements = getDrawerElements();

    function buttonMatches(button, skipPosition) {
      return multiState.positions.every(function (position) {
        var pick = multiState.picks[position];
        if (position === skipPosition || !pick) return true;
        return (button.getAttribute("data-option" + position) || "") === pick;
      });
    }

    forEachNode(
      elements.optionsList.querySelectorAll("[data-opt-value]"),
      function (valueButton) {
        var position = parseInt(valueButton.getAttribute("data-opt-position"), 10);
        var optionValue = valueButton.getAttribute("data-opt-value");
        var available = activeSourceButtons.some(function (button) {
          return (
            (button.getAttribute("data-option" + position) || "") === optionValue &&
            buttonMatches(button, position)
          );
        });
        if (!available && multiState.picks[position] === optionValue) {
          delete multiState.picks[position];
        }
        valueButton.disabled = !available;
        valueButton.classList.toggle(
          "is-selected",
          multiState.picks[position] === optionValue,
        );
        valueButton.setAttribute(
          "aria-pressed",
          multiState.picks[position] === optionValue ? "true" : "false",
        );
      },
    );

    forEachNode(
      elements.optionsList.querySelectorAll("[data-opt-group-value]"),
      function (valueLabel) {
        var position = parseInt(valueLabel.getAttribute("data-opt-group-value"), 10);
        var pick = multiState.picks[position];
        valueLabel.textContent = pick || "Select";
        valueLabel.classList.toggle("is-empty", !pick);
      },
    );

    if (
      multiState.positions.every(function (position) {
        return !!multiState.picks[position];
      })
    ) {
      activeSourceButtons.some(function (button, index) {
        if (buttonMatches(button, 0)) {
          matchIndex = index;
          return true;
        }
        return false;
      });
    }

    updateSelectedOption(matchIndex);
  }

  function pickMultiOption(position, optionValue) {
    if (!multiState) return;
    if (multiState.picks[position] === optionValue) return;
    multiState.picks[position] = optionValue;
    syncMultiOptionPicker();
  }

  function renderQuickAddOptions(container) {
    var elements = getDrawerElements();
    var sizeOptionPosition = parseInt(
      container.getAttribute("data-size-option-position") || "0",
      10,
    );
    var fallbackLink = container.querySelector("[data-quick-add-fallback]");

    var allSourceButtons = getAllSourceButtons(container);
    var multiPositions =
      allSourceButtons.length > 1
        ? getMultiOptionPositions(container, allSourceButtons)
        : [];

    multiState = null;
    elements.optionsList.classList.toggle(
      "QuickAddDrawer__Options--multi",
      multiPositions.length > 1,
    );
    if (multiPositions.length > 1) {
      renderMultiOptionPicker(
        container,
        elements,
        allSourceButtons,
        multiPositions,
      );
      return;
    }

    activeSourceButtons = getVisibleSourceButtons(container);
    selectedSourceIndex = -1;
    elements.optionsList.innerHTML = "";

    if (!activeSourceButtons.length) {
      if (fallbackLink) {
        var fallback = document.createElement("a");
        fallback.className = "QuickAddDrawer__Fallback";
        fallback.href =
          fallbackLink.getAttribute("href") ||
          container.getAttribute("data-product-url") ||
          "#";
        fallback.textContent = window.olyxGetLanguageString(
          "openProductPageOption",
          "Open the product page to choose your exact option.",
        );
        elements.optionsList.appendChild(fallback);
      }

      elements.submit.setAttribute("disabled", "disabled");
      elements.submitPrice.innerHTML = "";
      return;
    }

    forEachNode(activeSourceButtons, function (sourceButton, index) {
      var optionButton = document.createElement("button");
      var optionMeta = document.createElement("span");
      var optionLabel = document.createElement("span");
      var optionValue = document.createElement("span");
      var optionRight = document.createElement("span");
      var optionPrice = document.createElement("span");
      var sizeLabel =
        sourceButton.getAttribute("data-size-label") ||
        sourceButton.textContent ||
        sourceButton.getAttribute("data-variant-title") ||
        window.olyxGetLanguageString("defaultOptionLabel", "Default");

      optionButton.type = "button";
      optionButton.className = "QuickAddDrawer__Option";
      optionButton.setAttribute("data-quick-add-option", "true");
      optionButton.setAttribute("data-source-index", index);

      optionMeta.className = "QuickAddDrawer__OptionMeta";
      optionLabel.className = "QuickAddDrawer__OptionLabel";
      optionLabel.textContent = window.olyxGetLanguageString(
        sizeOptionPosition ? "sizeLabel" : "optionLabel",
        sizeOptionPosition ? "Size" : "Option",
      );
      optionValue.className = "QuickAddDrawer__OptionValue";
      optionValue.textContent = olyxQuickSizeLabel(sizeLabel);
      optionMeta.appendChild(optionLabel);
      optionMeta.appendChild(optionValue);

      optionRight.className = "QuickAddDrawer__OptionRight";

      optionPrice.className = "QuickAddDrawer__OptionPrice";
      optionPrice.innerHTML = buildMoneyMarkup(
        sourceButton.getAttribute("data-variant-price") || "0",
      );
      optionRight.appendChild(optionPrice);

      optionButton.appendChild(optionMeta);
      optionButton.appendChild(optionRight);
      elements.optionsList.appendChild(optionButton);
    });

    updateSelectedOption(0);
  }

  /* Nov 2026: quick buy shows "36 EU" (or "US 4" / "UK 3.5"), same as the product page */
  function olyxQuickSizeLabel(raw) {
    var t = String(raw || "").trim();
    var root = document.documentElement.classList;
    var sys = root.contains("olyx-sizes-us") ? "US" : root.contains("olyx-sizes-uk") ? "UK" : "EU";
    var parts = t.split("/").map(function (p) { return p.trim(); });
    var pick = function (re) {
      for (var i = 0; i < parts.length; i++) { var m = parts[i].match(re); if (m) return m[1]; }
      return "";
    };
    var eu = pick(/^EU\s+(.+)$/i);
    if (sys === "UK") { var uk = pick(/^UK\s+(.+)$/i); if (uk) return "UK " + uk; }
    if (sys === "US") {
      var us = parts.filter(function (p) { return /^US\b/i.test(p); });
      if (us.length) return us.join(" / ");
    }
    if (eu) return eu + " EU";
    if (/^\d{2}(\.5| ½| 1\/3| 2\/3)?$/.test(t) && sys === "EU") return t + " EU";
    return t;
  }

  function renderQuickAddColors(container) {
    var elements = getDrawerElements();
    var colorChoices = [];
    var selectedColor = activeColorValue;

    if (!elements.colorGroup || !elements.colorList || !elements.colorValue) {
      return;
    }

    elements.colorList.innerHTML = "";

    if (!activeColorPosition) {
      elements.colorGroup.hidden = true;
      elements.colorValue.textContent = "";
      return;
    }

    colorChoices = getQuickAddColorChoices(container);

    if (colorChoices.length <= 1) {
      elements.colorGroup.hidden = true;
      elements.colorValue.textContent = colorChoices[0] || "";
      if (!selectedColor && colorChoices[0]) {
        activeColorValue = colorChoices[0];
      }
      return;
    }

    if (!selectedColor || colorChoices.indexOf(selectedColor) === -1) {
      selectedColor = colorChoices[0] || "";
      activeColorValue = selectedColor;
    }

    elements.colorGroup.hidden = false;
    elements.colorValue.textContent = selectedColor;

    forEachNode(colorChoices, function (colorChoice) {
      var colorButton = document.createElement("button");

      colorButton.type = "button";
      colorButton.className = "QuickAddDrawer__ColorOption";
      colorButton.setAttribute("data-quick-add-color", "true");
      colorButton.setAttribute("data-color-value", colorChoice);
      colorButton.classList.toggle(
        "is-selected",
        colorChoice === selectedColor,
      );
      colorButton.textContent = colorChoice;
      elements.colorList.appendChild(colorButton);
    });
  }

  function renderQuickAddDrawer(container) {
    var elements = getDrawerElements();
    var productUrl = container.getAttribute("data-product-url") || "#";
    /* payment icons: printed once per page (snippets/olyx-fixes.liquid) instead of in every card */
    var paymentMarkup =
      container.querySelector("[data-quick-add-payments]") ||
      document.getElementById("OlyxQuickAddPayments");

    syncQuickAddStaticLabels(elements);

    activeColorPosition = parseInt(
      container.getAttribute("data-color-option-position") || "0",
      10,
    );

    if (!activeColorValue && activeProductItem && activeColorPosition) {
      activeColorValue =
        getSelectedOptions(activeProductItem, container)[activeColorPosition] ||
        "";
    }

    elements.title.textContent = container.getAttribute(
      "data-size-option-position",
    )
      ? window.olyxGetLanguageString("chooseSize", "Choose size")
      : window.olyxGetLanguageString("quickAddTitle", "Quick add");
    if (elements.badge) {
      if (container.getAttribute("data-quick-shipping") === "true") {
        elements.badge.hidden = false;
        elements.badge.textContent = window.olyxGetLanguageString(
          "shippingWithin48Hours",
          "Free tracked shipping",
        );
      } else {
        elements.badge.hidden = true;
        elements.badge.textContent = "";
      }
    }
    elements.productImage.src = getSummaryImage(container);
    elements.productImage.alt =
      container.getAttribute("data-product-title") || "";
    elements.productTitle.textContent =
      container.getAttribute("data-product-title") || "";
    elements.productPrice.innerHTML = buildMoneyMarkup(
      container.getAttribute("data-product-price") || "0",
    );
    elements.payments.innerHTML = paymentMarkup ? paymentMarkup.innerHTML : "";

    forEachNode(elements.productLinks, function (link) {
      link.setAttribute("href", productUrl);
    });

    setQuickAddStatus("");
    renderQuickAddColors(container);
    renderQuickAddOptions(container);
    setDrawerState("picker");
  }

  function openQuickAdd(container) {
    var trigger;

    if (!container) {
      return;
    }

    activeContainer = container;
    activeProductItem = container.closest("[data-product-item]");

    if (activeProductItem) {
      syncQuickAdd(activeProductItem);
    }

    renderQuickAddDrawer(container);
    setDrawerOpen(true);

    trigger = container.querySelector("[data-quick-add-open]");

    if (trigger) {
      trigger.setAttribute("aria-expanded", "true");
    }
  }

  function openCartDrawer() {
    // Cart Drawer Pro exposes a global opener.
    if (typeof window.olyxOpenCartDrawer === "function") {
      window.olyxOpenCartDrawer();
      return;
    }

    // Fallback: click any cart link (intercepted by the drawer) or go to /cart.
    var cartLink = document.querySelector(
      'a[href$="/cart"], a[href*="/cart?"]',
    );

    if (cartLink) {
      cartLink.click();
      return;
    }

    window.location.href = "/cart";
  }

  function addVariantToCart() {
    var sourceButton = activeSourceButtons[selectedSourceIndex];
    var currentContainer = activeContainer;
    var currentProductItem = activeProductItem;
    var variantId = parseInt(
      sourceButton && sourceButton.getAttribute("data-variant-id")
        ? sourceButton.getAttribute("data-variant-id")
        : "0",
      10,
    );
    var elements = getDrawerElements();

    if (
      !currentContainer ||
      !sourceButton ||
      !variantId ||
      currentContainer.getAttribute("data-loading") === "true"
    ) {
      return;
    }

    currentContainer.setAttribute("data-loading", "true");
    elements.submit.classList.add("is-loading");
    elements.submit.setAttribute("disabled", "disabled");
    setQuickAddStatus(
      window.olyxGetLanguageString("addingToCart", "Adding..."),
      "neutral",
    );

    fetch("/cart/add.js", {
      credentials: "same-origin",
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }

        return response.json().then(function (payload) {
          throw new Error(
            payload.description ||
              window.olyxGetLanguageString(
                "unableToAddItem",
                "Unable to add this item.",
              ),
          );
        });
      })
      .then(function (item) {
        setQuickAddStatus(
          window.olyxGetLanguageString("addedToCart", "Added to cart"),
          "success",
        );

        if (currentProductItem) {
          currentProductItem.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                variant: item,
                quantity: 1,
              },
            }),
          );
        }

        if (activeContainer === currentContainer) {
          setDrawerOpen(false);
          window.setTimeout(openCartDrawer, 120);
        }
      })
      .catch(function (error) {
        setQuickAddStatus(
          error && error.message
            ? error.message
            : window.olyxGetLanguageString(
                "unableToAddItem",
                "Unable to add this item.",
              ),
          "error",
        );
      })
      .then(function () {
        currentContainer.removeAttribute("data-loading");
        elements.submit.classList.remove("is-loading");
        if (activeContainer === currentContainer && selectedSourceIndex >= 0) {
          elements.submit.removeAttribute("disabled");
        }
      });
  }

  function initQuickAdd(root) {
    forEachNode(
      (root || document).querySelectorAll("[data-product-item]"),
      function (productItem) {
        syncQuickAdd(productItem);
      },
    );
  }

  document.addEventListener("DOMContentLoaded", function () {
    initQuickAdd(document);
  });

  document.addEventListener("mouseover", function (event) {
    var productItem = event.target.closest("[data-product-item]");

    if (productItem) {
      syncQuickAdd(productItem);
    }
  });

  document.addEventListener("focusin", function (event) {
    var productItem = event.target.closest("[data-product-item]");

    if (productItem) {
      syncQuickAdd(productItem);
    }
  });

  document.addEventListener("change", function (event) {
    if (
      event.target &&
      event.target.matches(".ColorSwatch__Radio[data-option-position]")
    ) {
      var productItem = event.target.closest("[data-product-item]");

      if (productItem) {
        syncQuickAdd(productItem);
      }
    }
  });

  document.addEventListener("click", function (event) {
    var openTrigger = event.target.closest("[data-quick-add-open]");
    var closeTrigger = event.target.closest("[data-quick-add-close]");
    var navigationTrigger = event.target.closest(
      "[data-quick-add-product-link], .QuickAddDrawer__Fallback",
    );
    var colorTrigger = event.target.closest("[data-quick-add-color]");
    var optionTrigger = event.target.closest("[data-quick-add-option]");
    var multiTrigger = event.target.closest(".QuickAddDrawer [data-opt-value]");
    var submitTrigger = event.target.closest("[data-quick-add-submit]");

    if (openTrigger) {
      event.preventDefault();
      openQuickAdd(openTrigger.closest("[data-quick-add-container]"));
      return;
    }

    if (closeTrigger) {
      event.preventDefault();
      setDrawerOpen(false);
      return;
    }

    if (navigationTrigger) {
      setDrawerOpen(false);
      return;
    }

    if (colorTrigger) {
      event.preventDefault();
      updateSelectedColor(colorTrigger.getAttribute("data-color-value") || "");
      return;
    }

    if (multiTrigger) {
      event.preventDefault();
      if (!multiTrigger.disabled) {
        pickMultiOption(
          parseInt(multiTrigger.getAttribute("data-opt-position"), 10),
          multiTrigger.getAttribute("data-opt-value") || "",
        );
      }
      return;
    }

    if (optionTrigger) {
      event.preventDefault();
      updateSelectedOption(
        parseInt(optionTrigger.getAttribute("data-source-index") || "-1", 10),
      );
      return;
    }

    if (!submitTrigger) return;

    event.preventDefault();
    addVariantToCart();
  });

  document.addEventListener("keyup", function (event) {
    if (event.key === "Escape" && quickAddDrawer) {
      setDrawerOpen(false);
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", resetQuickAddDrawerState);
  } else {
    resetQuickAddDrawerState();
  }

  window.addEventListener("pageshow", resetQuickAddDrawerState);
  window.addEventListener("pagehide", function () {
    unlockQuickAddPageScroll(false);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initQuickAdd(event.target);
  });
})();

// ============================================
// Product Page Accordions
// ============================================
document.addEventListener("click", function (event) {
  var header = event.target.closest ? event.target.closest(".ProductAccordion__Header") : null;
  if (!header) return;
  var parent = header.parentElement;
  var content = header.nextElementSibling;
  var isActive = parent.classList.contains("is-active");

  if (isActive) {
    parent.classList.remove("is-active");
    header.setAttribute("aria-expanded", "false");
    if (content) content.style.display = "none";
  } else {
    parent.classList.add("is-active");
    header.setAttribute("aria-expanded", "true");
    if (content) content.style.display = "block";
  }
});

// ==========================================
// Scroll Position Restore (Back Navigation)
// ==========================================
(function () {
  "use strict";

  var isScrollPage =
    window.location.pathname.indexOf("/collections/") === 0 ||
    window.location.pathname.indexOf("/search") === 0;
  if (!isScrollPage) return;

  var key = "scrollPos:" + window.location.href;

  // Save scroll position on scroll (throttled)
  var scrollTimer;
  window.addEventListener(
    "scroll",
    function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        try {
          sessionStorage.setItem(key, window.scrollY);
        } catch (e) {}
      }, 100);
    },
    { passive: true },
  );

  // Restore scroll position after back/forward navigation
  function restoreScroll() {
    try {
      var saved = sessionStorage.getItem(key);
      if (saved !== null) {
        sessionStorage.removeItem(key);
        window.scrollTo(0, parseInt(saved, 10));
      }
    } catch (e) {}
  }

  // pageshow fires for bfcache (back button) restores
  window.addEventListener("pageshow", function (e) {
    if (e.persisted) {
      restoreScroll();
    }
  });

  document.addEventListener("DOMContentLoaded", restoreScroll);
})();
